/* eslint-disable class-methods-use-this */
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { PersonalInfoWizard } from '../../../../account-info/features/personal-info/wizard/personal-info-wizard';
import { ArcRoutes } from '../../../constants/routes';
import { NewHireStep } from '../../new-hire/models/new-hire-model';
import { NewHireEnrollmentStep } from '../models/new-hire-enrollment-models';
import { setCurrentNewHireEmployeeReviewStep, setCurrentNewHireEnrollmentStep } from '../slice/new-hire-enrollment-slices';


export class NewHireEnrollmentPersonalInfoWizard extends PersonalInfoWizard {



	public getPageDescription(): string {
		return this.epiContent?.personalInfoSettingState?.epiContent?.pageIntro;
	}

	public getPageHeader(): string {
		return this.epiContent?.personalInfoSettingState?.epiContent?.pageTitle;
	}

	public useEffectDispatch(): void {
		this.dispatch(setCurrentNewHireEnrollmentStep(NewHireEnrollmentStep.EMPLOYEE_RECORD));
		this.dispatch(setCurrentNewHireEmployeeReviewStep(NewHireStep.PersonalInfo));

	}

	public onSuccessRedirect(basePath: string): void {
		this.history.push(`${basePath}${ArcRoutes.Employment}`);
		this.dispatch(setCurrentNewHireEmployeeReviewStep(NewHireStep.PersonReviewInternal));

	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public onSuccessNoChanges(basePath: string): void {
	}

	public isEnrollmentForm(): boolean {
		return true;
	}

	public isAnnualEnrollmentForm(): boolean {
		return false;
	}

	public getGpsType(): GpsType {
		return GpsType.NEW_HIRE_PERSONAL_INFO;
	}

	public getSubmitButtonText() {
		return this.epiContent?.newHireSettingsState?.epiContent?.continueToEmploymentCompButtonText;
	}

	public getCancelButtonText() {
		return this.epiContent?.personalInfoSettingState?.epiContent?.cancelText;
	}

	public hasMaritalStatusSection(): boolean {
		return !this.isEnrollmentForm();
	}

	public preventButtonDisableValidation(): boolean {
		return this.isEnrollmentForm();
	}
}